import { render, staticRenderFns } from "./strava.svg.vue?vue&type=template&id=1a7067a4&"
import script from "./strava.svg.vue?vue&type=script&lang=js&"
export * from "./strava.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports